import axios from '@/axios'
import { downloadFile } from '@/utils/functions';

export default {
    namespaced: true,

    actions: {
        fetchAll({ commit }, { fromDate, toDate, sectionId, employeeIds, jobDescriptionId, page, perPage }) {
            return axios.get('/salaries', {
                params: { fromDate, toDate, sectionId, employeeIds, jobDescriptionId, page, perPage, nonDeleted: true }
            }).then(({ data, headers }) => {
                return {
                    items: data,
                    totalItems: +headers['x-pagination-total-count']
                };
            })
        },

        fetchEmployeeSalaryDetails({ commit }, { employeeId, date }) {
            return axios.get(`/salaries/details/${employeeId}`, { params: { date } }).then(({ data }) => data)
        },

        calculateEmployeesSalaries({ commit }, { sectionId, employeeIds, month }) {
            return axios.post('/salaries/employees', { sectionId, employeeIds, month });
        },

        calculateEmployeeSalaries({ commit }, { employeeId }) {
            return axios.post(`/salaries/employees/${employeeId}`);
        },

        exportExcelSalaries({ commit }, { date }) {
            return axios.post('/salaries/export/All', null, {
                params: { date }, responseType: 'blob'
            }).then((res) => {
                const url = URL.createObjectURL(res.data);
                downloadFile(url, `تقرير رواتب الموظفين لشهر ${date}`);
                URL.revokeObjectURL(url);
            })
        },
        // new interface
        fetchSalariesDetails ({ commit }, { from, to, jobDescription, sectionId }) {
            return axios.get('/Attendances/ShowCalculateAttendance', { 
                params: { from, to, jobDescription,sectionId } 
            }).then(({ data }) => {
                return data
            })
        },

        fetchSalary ({ commit }, { from, to, jobDescription, sectionId }) {
            return axios.get('/Salaries/ShowCalculatedSalary', { 
                params: { from, to, jobDescription, sectionId } 
            }).then(({ data }) => {
                return data
            })
        }
        
    },
}